<template>
  <div class="s-service-slider">
    <ServiceImagesSlider
      class="s-service-slider__images"
      :images="data.images"
    />
    <div class="s-service-slider__info">
      <h2 class="s-service-slider__title">
        {{ data | localeField("name") }}
      </h2>
      <span
        v-if="$options.filters.localeField(data, 'description')"
        v-html="$options.filters.localeField(data, 'description')"
        class="s-service-slider__subtitle"
      >
      </span>
    </div>
  </div>
</template>

<script>
import ServiceImagesSlider from "./ServiceImagesSlider.vue";

export default {
  name: "ServiceSliderSection",
  components: {
    ServiceImagesSlider
  },
  props: {
    data: Object
  }
};
</script>

<style lang="scss">
@import "swiper/swiper";

.s-service-slider {
  display: flex;
  align-items: flex-start;
  background: var(--white);
  border-radius: 2px;
  padding: 30px;
  @media (max-width: 600px) {
    flex-direction: column;
    padding: 15px;
  }

  &__images {
    margin-right: 30px;
  }

  &__title {
    color: var(--dark);
    font-size: 1rem;
    font-weight: 700;
    line-height: 24px;
    margin: 0 0 15px;
  }

  &__subtitle {
    color: var(--gray-dark);
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }
}
</style>
